import AxiosControl from '../components/axios/AxiosControl'
import i18n from 'i18next'
const Axios = AxiosControl()

export const sendChatbotMessage = (message, history = []) => async (dispatch) => {
    dispatch({
        type: 'CHATBOT_LOADING'
    })

    dispatch({
        type: 'CHATBOT_ADD_USER_MESSAGE',
        payload: {
            role: 'user',
            content: message
        }
    })

    try {
        const { data, status } = await Axios.post('/api/chatbot/ask', { message, history },
            {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )

        if (status === 200) {
            dispatch({
                type: 'CHATBOT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHATBOT_NOT_LOADING'
        })

        dispatch({
            type: 'CHATBOT_ADD_BOT_MESSAGE',
            payload: {
                role: 'assistant',
                content: i18n.t('chatbot.responseError')
            }
        })
    }
}

export const clearChatbotMessages = () => async (dispatch) => {
    dispatch({
        type: 'CHATBOT_CLEAR_MESSAGES'
    })
}

export const getMyChatbotHistory = (limit = 50) => async (dispatch) => {
    dispatch({
        type: 'CHATBOT_HISTORY_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/chatbot/my-logs', {
            params: { limit },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 && data?.ok) {
            dispatch({
                type: 'CHATBOT_HISTORY_SUCCESS',
                payload: data.data.logs || []
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHATBOT_HISTORY_ERROR'
        })
    }
}

export const restoreChatbotHistoryItem = (log) => async (dispatch) => {
    if (!log) return
    const messages = []
    if (log.question) messages.push({ role: 'user', content: log.question })
    if (log.answer) messages.push({ role: 'assistant', content: log.answer })
    dispatch({
        type: 'CHATBOT_RESTORE_MESSAGES',
        payload: messages
    })
}

export const getChatbotLogs = () => async (dispatch) => {
    dispatch({
        type: 'CHATBOT_LOG_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/chatbot/logs', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 && data?.ok) {
            dispatch({
                type: 'CHATBOT_LOG_SUCCESS',
                payload: data.data.logs || []
            })
        }
    } catch (error) {
        dispatch({
            type: 'CHATBOT_LOG_ERROR'
        })
    }
}